import React from "react";
import { Modal, Button, ModalHeader, ModalBody, ModalFooter } from 'react-bootstrap';
import SubscriptionIcon from "assets/images/images_new/subscription-icon.svg";
const ModalSkeleton = ({
  status,
  toggle,
  handleClick,
  btnText,
  message,
  data,
  isSmall,
}) => {
  return (
    <Modal show={status} centered className="text-translate-modal">
      <ModalHeader className="text-translation" tag="div">
        <div className="modal-title">

          <img src={SubscriptionIcon} alt="LA" style={{ marginRight: "10px" }} />

          Unlock Premium Content
          <Button className="modalCloseBtn" onClick={() => toggle()}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              width="24"
              height="24"
            >
              <path
                d="M18 6L6 18M6 6l12 12"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </Button>
        </div>
      </ModalHeader>
      <ModalBody>
        <div className="row">
          <h2 className="translate-title">{message}</h2>

        </div>
      </ModalBody>
      <ModalFooter className="d-flex justify-content-start" style={{paddingBottom:"10px"}}>
        <Button
          onClick={handleClick}
          className="outline-btn pull-left text-center"
        >
          {btnText}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default ModalSkeleton;
